import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Button, Popover, PopoverBody, UncontrolledPopover, PopoverHeader } from 'reactstrap';
import { number, string, object, oneOfType, func, array } from 'prop-types';
import CustomTable from '../../../../components/CustomTable/CustomTable';
import PixelsGroupList from '../../../../components/Pixels/OLD_PixelsGroupList';
import PixelShortItem from './PixelShortItem';
import OfferGeoPrices from '../../../../components/Offer/OfferGeoPrices';
import { currencyToSign, getStoreUrl } from '../../../../utils/utils';
import { STATIC_PATH } from '../../../../config';
import { FMessage } from '../../../../hoc/IntlComponents';
import { startRefuseOfferAccess } from '../../../../actions/webmaster';

class OffersListItem extends Component {
  static propTypes = {
    id: number.isRequired,
    title: string.isRequired,
    stats: array.isRequired,
    modifies: object.isRequired,
    short_pixels: object.isRequired,
    pixels: oneOfType([object, array]).isRequired,
    geo: array.isRequired,
    images: object.isRequired,
    offerSettings: object,
    countriesList: array,
    onRequestOfferAccess: func,
    scrollPosition: object,
    onFlowCreate: func.isRequired,
    globalCurrencies: array.isRequired,
  };

  static defaultProps = {
    countriesList: [],
    forbiddenGeo: [],
  };

  state = {
    popoverOpen: false,
    popoverTarget: '',
  };

  toggle = (id) => {
    this.setState((prevState) => ({
      popoverOpen: !prevState.popoverOpen,
      popoverTarget: id,
    }));
  };

  closePopover = () => {
    this.setState(() => ({
      popoverOpen: false,
      popoverTarget: '',
    }));
  };

  getStats = (stat, isNew, sign) =>
    isNew ? 'NEW' : stat > 0 ? `${stat} ${currencyToSign(sign)}` : '—';

  getOfferStats = (stats = [], type, period, sign) => {
    const stat = stats.find((stat) => stat.period === period);
    return this.getStats(stat[type], stat.new, sign);
  };

  renderCountriesList = (targetId) => {
    const { countriesList, forbiddenGeo, modifies } = this.props;
    const { popoverTarget } = this.state;
    const geoCount = countriesList.length;
    const forbiddenGeoCount = forbiddenGeo.length;

    if (!geoCount) {
      if (!forbiddenGeoCount) {
        return (
          <div className="offer-geo-list offer-geo-list--empty">
            <FormattedMessage id="offers.table.geo.all" defaultMessage="The whole world" />
          </div>
        );
      } else {
        return (
          <div
            className="offer-geo-list"
            onClick={() => {
              if (!popoverTarget.includes('offer-pixels-list')) {
                this.toggle(targetId);
              }
            }}
          >
            <FormattedMessage id="offers.table.geo.all" defaultMessage="The whole world" />
          </div>
        );
      }
    }
    if (geoCount === 1) {
      return (
        <div
          className="offer-geo-list offer-geo-list--empty"
          title={string}
          onClick={() => {
            if (modifies.is_cdn && !popoverTarget.includes('offer-pixels-list')) {
              this.toggle(targetId);
            }
          }}
        >
          <Fragment>{this.props.countriesList[0]}</Fragment>
        </div>
      );
    } else {
      return (
        <ul className="list-unstyled offers-list-geo-item-list">
          {countriesList.map((country) => (
            <li key={country}>{country}</li>
          ))}
        </ul>
      );
    }
  };

  renderPixelsPopover = () => {
    const {
      modifies,
      pixels,
      short_pixels,
      countriesList,
      id,
      forbiddenGeo,
      offer_geo,
      countries,
    } = this.props;
    const { popoverTarget } = this.state;

    if (typeof short_pixels === 'undefined' || typeof pixels === 'undefined' || !popoverTarget)
      return null;

    const geoCount = countriesList.length;
    const forbiddenGeoCount = forbiddenGeo.length;

    let popover = null;
    if (modifies.is_cdn && !popoverTarget.includes('offer-pixels-list')) {
      return (
        <Popover
          className="popover-pixels geo-prices in-popup"
          placement="right"
          trigger="legacy"
          target={popoverTarget}
          toggle={() => this.toggle(popoverTarget)}
          isOpen={this.state.popoverOpen}
        >
          <PopoverBody>
            <OfferGeoPrices items={offer_geo} countries={countries} offerId={id} inPopup />
          </PopoverBody>
        </Popover>
      );
    }

    if (modifies.is_cdn) {
      popover = (
        <Popover
          className="popover-pixels"
          placement="right"
          trigger="legacy"
          target={popoverTarget}
          toggle={() => this.toggle(popoverTarget)}
          isOpen={this.state.popoverOpen}
        >
          <PopoverBody>
            <PixelsGroupList groups={pixels} isCdn={modifies.is_cdn} coins={modifies.coins} />
          </PopoverBody>
        </Popover>
      );
    } else {
      if (!geoCount) {
        if (forbiddenGeoCount) {
          popover = (
            <Popover
              className="popover-pixels"
              placement="right"
              trigger="legacy"
              target={popoverTarget}
              toggle={() => this.toggle(popoverTarget)}
              isOpen={this.state.popoverOpen}
            >
              <PopoverBody>
                <ul className="list-unstyled no-margin">
                  <span className="popover-pixels-title">
                    <FormattedMessage id="offers.geo.except" defaultMessage="Except:" />
                  </span>
                  {forbiddenGeo.map((country) => (
                    <li key={`${country}_${id}`}>{country}</li>
                  ))}
                </ul>
              </PopoverBody>
            </Popover>
          );
        }
      } else {
        if (modifies.is_cdn && !popoverTarget.includes('offer-pixels-list')) {
          popover = (
            <Popover
              className="popover-pixels"
              placement="right"
              trigger="legacy"
              target={popoverTarget}
              toggle={() => this.toggle(popoverTarget)}
              isOpen={this.state.popoverOpen}
            >
              <PopoverBody>
                <ul className="list-unstyled no-margin">
                  {countriesList.map((country) => (
                    <li key={`${country}_${id}`}>{country}</li>
                  ))}
                </ul>
              </PopoverBody>
            </Popover>
          );
        }
      }
    }
    return popover;
  };

  renderPixels = () => {
    const { modifies, pixels, short_pixels, id, countriesList, offer_geo, countries } = this.props;
    const geoCount = countriesList.length;
    const pixelsPopover = this.renderPixelsPopover();
    return (
      <Fragment>
        {modifies.is_cdn ? (
          <FormattedMessage id="offers.table.geo.title" defaultMessage="Click for more">
            {(string) => (
              <PixelShortItem
                countries={countries}
                pixels={pixels}
                geo={offer_geo}
                pixel={short_pixels}
                id={`offer-pixels-list-${id}`}
                onClick={() => (geoCount > 1 ? this.toggle(`offer-pixels-list-${id}`) : false)}
                role={geoCount > 1 ? 'button' : 'initial'}
                title={geoCount > 1 ? string : ''}
              />
            )}
          </FormattedMessage>
        ) : (
          <PixelsGroupList groups={pixels} />
        )}
        {pixelsPopover}
      </Fragment>
    );
  };

  renderCoinTooltip = ({ id, target, coins }) => {
    return (
      <UncontrolledPopover
        trigger="hover"
        className="offer-coins-popover"
        placement="left"
        target={`${target}-${id}`}
      >
        <PopoverHeader>
          {' '}
          <b>
            <FMessage id="offer.tooltip.header" />
          </b>
        </PopoverHeader>
        <PopoverBody>
          {' '}
          <div>
            <FormattedMessage
              id="offer.tooltip.p"
              defaultMessage="According to this offer,  {coins, plural, one {# coin} other {# coins} } is charged for a confirmed application. Coins you can spend on "
              values={{
                coins,
              }}
            />
            <a href={getStoreUrl()} target="_blank">
              <FMessage id="offer.tooltip.link-to-store" />
            </a>
          </div>
        </PopoverBody>
      </UncontrolledPopover>
    );
  };

  renderCoins = () => {
    const {
      modifies: { coins },
      id,
    } = this.props;
    if (coins === 1) {
      return (
        <div id={`coins-${coins}-${id}`} className={`coins-${coins}`}>
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          {this.renderCoinTooltip({ id, target: `coins-${coins}`, coins })}
        </div>
      );
    } else if (coins === 2) {
      return (
        <div id={`coins-${coins}-${id}`} className={`coins-${coins}`}>
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          <img src={`${STATIC_PATH}/img/coin-big.svg`} />
          {this.renderCoinTooltip({ id, target: `coins-${coins}`, coins })}
        </div>
      );
    }
    return null;
  };

  getOfferImgSrc = () => {
    const { images, offerSettings } = this.props;
    if (
      (!images || (images && !images[100])) &&
      (!offerSettings || (offerSettings && !offerSettings['images_path']))
    ) {
      return null;
    } else {
      return `${offerSettings['images_path']}${images[100].replace('100x100', '200x200')}`;
    }
  };

  handleRemoveOffer = (id) => this.props.removeOffer(id);

  render() {
    const {
      id,
      title,
      stats,
      modifies,
      onRequestOfferAccess,
      onFlowCreate,
      globalCurrencies,
      history,
      admit,
    } = this.props;

    const gamblingOrDating = modifies.g || modifies.d;
    const [baseCurrency] = globalCurrencies;

    return (
      <CustomTable.Row className="offers-list-item">
        <CustomTable.Cell>
          <div className="offer-pic">
            <img className="img-fluid" src={`${this.getOfferImgSrc()}?1`} alt="" />
            {this.renderCoins()}
          </div>
        </CustomTable.Cell>

        <CustomTable.Cell>
          {modifies.is_private ? (
            <span>{title}</span>
          ) : (
            <Link
              className="offer-title"
              to={
                modifies.no_access
                  ? `/tickets/create?theme=getPrivateOffers&offer=${id}`
                  : `/offers/${id}`
              }
            >
              {title}
            </Link>
          )}
          <div className="badges">
            {modifies.exclusive && <span className="badge badge-danger mr-1">exclusive</span>}
            {modifies.is_new && <span className="badge badge-success mr-1">new</span>}
            {admit.private && <span className="badge badge-private">private</span>}
          </div>
        </CustomTable.Cell>

        <CustomTable.Cell
          className={cn(
            {
              blur: modifies.is_private || modifies.no_access,
              'hidden-text': modifies.is_private || modifies.no_access,
            },
            'offer-prices-cell',
          )}
        >
          {this.renderPixels()}
        </CustomTable.Cell>

        <CustomTable.Cell
          id={`offer-pixels-${id}`}
          className={cn(
            {
              blur: modifies.is_private || modifies.no_access,
              'hidden-text': modifies.is_private || modifies.no_access,
            },
            'offers-list-geo-item',
          )}
        >
          {this.renderCountriesList(`offer-pixels-${id}`)}
        </CustomTable.Cell>

        <CustomTable.Cell
          className={cn(
            {
              blur: modifies.is_private || modifies.no_access,
              'hidden-text': modifies.is_private || modifies.no_access,
            },
            'text-right',
          )}
        >
          {!modifies.g ? this.getOfferStats(stats, 'cr', 'week', '%') : '-'}
        </CustomTable.Cell>

        <CustomTable.Cell
          className={cn(
            {
              blur: modifies.is_private || modifies.no_access,
              'hidden-text': modifies.is_private || modifies.no_access,
            },
            'text-right',
          )}
        >
          {!modifies.g ? this.getOfferStats(stats, 'epc', 'week', baseCurrency) : '-'}
        </CustomTable.Cell>

        <CustomTable.Cell
          className={cn(
            {
              blur: modifies.is_private || modifies.no_access,
              'hidden-text': modifies.is_private || modifies.no_access,
            },
            'text-right',
          )}
        >
          {!gamblingOrDating ? this.getOfferStats(stats, 'rate', 'week', '%') : '-'}
        </CustomTable.Cell>

        <CustomTable.Cell className="text-right action">
          {modifies.is_my ? (
            <>
              <Button
                color="secondary"
                size="sm"
                className="mb-2"
                // onClick={onFlowCreate.bind(null, id)}
                onClick={() => history.push(`/offers/${id}`)}
              >
                <FormattedMessage
                  id="offer.buttons.create-flow.theme_4"
                  defaultMessage="Create flow"
                />
              </Button>
              <Button
                color="danger"
                size="sm"
                // onClick={onFlowCreate.bind(null, id)}
                onClick={this.handleRemoveOffer.bind(null, id)}
              >
                <FormattedMessage id="offer.buttons.remove-offer" defaultMessage="Remove offer" />
              </Button>
            </>
          ) : modifies.is_private ? (
            <span className="private-access-text">
              <i className="icon-lock" />{' '}
              <span>
                <FormattedMessage id="offers.private-access" defaultMessage="Private access" />
              </span>
            </span>
          ) : modifies.no_access ? (
            <Button
              tag={Link}
              to={`/tickets/create?theme=getPrivateOffers&offer=${id}`}
              color="secondary"
              size="sm"
            >
              <FormattedMessage id="offer.buttons.get-access" defaultMessage="Get access" />
            </Button>
          ) : (
            <Button
              type="button"
              color="secondary"
              size="sm"
              onClick={() => onRequestOfferAccess(id, title)}
            >
              <FormattedMessage id="offer.buttons.add-offer" defaultMessage="Add" />
            </Button>
          )}
        </CustomTable.Cell>
        {modifies.no_access && (
          <div className="private-access">
            <i className="icon-lock" />{' '}
            <span>
              <FormattedMessage id="offers.private-access" defaultMessage="Private access" />
            </span>
          </div>
        )}
      </CustomTable.Row>
    );
  }
}

const mapDispatchToProps = {
  startRefuseOfferAccess,
};

export default connect(undefined, mapDispatchToProps)(withRouter(OffersListItem));
